import { FC } from "react";

import IconProps from "./IconProps";

const ExternalLinkIcon: FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17595_2862)">
      <path
        d="M9.99992 5H4.99992C4.55789 5 4.13397 5.17559 3.82141 5.48816C3.50885 5.80072 3.33325 6.22464 3.33325 6.66667V15C3.33325 15.442 3.50885 15.866 3.82141 16.1785C4.13397 16.4911 4.55789 16.6667 4.99992 16.6667H13.3333C13.7753 16.6667 14.1992 16.4911 14.5118 16.1785C14.8243 15.866 14.9999 15.442 14.9999 15V10"
        stroke="#627293"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.16675 10.8335L16.6667 3.3335"
        stroke="#627293"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 3.3335H16.6667V7.50016"
        stroke="#627293"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17595_2862">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ExternalLinkIcon;
